
namespace MACRAIL {

export class StickyHeader {

    private opts: StickyHeaderOptions;

    private element: JQuery;

    private oldTop: number = 0;

    public constructor(element: JQuery, opts: StickyHeaderOptions) {

        this.element = element;
        this.opts = opts;

        $('#content-container').prepend(element);

        element.css({
            'position': 'fixed',
            'top': $('#header').height() + 'px',
            'width': '100%',
            'zIndex': 9,
        });

        this.recalculate();
        // setInterval(() => { this.recalculate(); }, 1000);
    }

    public recalculate() {
        // Don't like all this calculating, but it does work.
        let newTop = Math.ceil($('#header').height() + this.element.outerHeight());
        if (newTop !== this.oldTop) {
            $('#content').css('padding-top', newTop + 'px');
            this.oldTop = newTop;
            if (this.opts.callback) {
                this.opts.callback(newTop);
            }
        }
    }
}


interface StickyHeaderOptions {

    callback: (newTop: number) => void;

}

}
